export const DEFAULT_SIZE = 24